"use strict";
/**
 * @module "ethpm/registries/web3"
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bn_js_1 = __importDefault(require("bn.js"));
const paged_1 = __importDefault(require("./paged"));
class ReleasesCursor extends paged_1.default {
    constructor(pageSize, length, web3, registry, packageName, releaseIds) {
        super(pageSize);
        this.pointer = new bn_js_1.default(0);
        this.length = length.clone();
        this.web3 = web3;
        this.packageName = packageName;
        this.registry = registry;
        this.releaseIds = releaseIds;
        this.setPages(this.releaseIds);
    }
    getReleaseData() {
        const promise = new Promise((resolve) => {
            const releaseId = this.getDatum(this.pointer);
            if (releaseId === null) {
                resolve(undefined);
            }
            else {
                this.registry.methods.getReleaseData(releaseId).call().then((result) => resolve(result));
            }
        });
        this.pointer = this.pointer.addn(1);
        return {
            done: false,
            value: promise,
        };
    }
    next() {
        if (this.pointer.lt(this.length)) {
            return this.getReleaseData();
        }
        return {
            done: true,
            value: undefined,
        };
        const promise = new Promise((resolve) => {
            resolve(undefined);
        });
        this.pointer = this.pointer.addn(1);
        return {
            done: true,
            value: promise,
        };
    }
    [Symbol.iterator]() {
        return this;
    }
}
exports.default = ReleasesCursor;
